import { css } from 'styled-components';

export const CookieBotStyles = css`
  #CookiebotWidget {
    display: none !important;
  }

  #CybotCookiebotDialog {
    top: auto !important;
    bottom: 0 !important;
    transform: translate(-50%, 0) !important;
  }

  #CybotCookiebotDialogHeader {
    display: none !important;
  }
`;
